import React from 'react';
import { HipHopServers } from './components/HipHopServers';
export function App() {
  return <HipHopServers data-id="element-0" />;
}